// extracted by mini-css-extract-plugin
export default {"account_page":"account_account_page__8JQ-k","content":"account_content__39LAF","inactive_programs_title":"account_inactive_programs_title__hP6QE"};